import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class StockAdjustmentsApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/stock-adjustments' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getInfo(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/stock-adjustments/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCreate(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/stock-adjustments/create' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async create(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/stock-adjustments/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/stock-adjustments/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async update(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/stock-adjustments/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async confirm(id) {
		try {
			const response = await axios.put(BASE_URI + '/v1/stock-adjustments/' + id + '/confirm' + signature(), '', config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async cancel(id) {
		try {
			const response = await axios.put(BASE_URI + '/v1/stock-adjustments/' + id + '/cancel' + signature(), '', config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const StockAdjustments = new StockAdjustmentsApi();
